// Route names constants.js
export default {
    RN_HOME: "Home",
    RN_DASHBOARD: "Dashboard",
    RN_USER_SETTINGS: "UserSettings",
    RN_LOGIN: "Login",
    RN_USER_LIST:"UserList",
    RN_CLIENTS:"ClientList",
    RN_CLIENT_NEW:"ClientNew",
    RN_RESET_PASSWORD:"ResetPassword",
    RN_SET_PASSWORD:"ResetPassword",
    RN_TRANSACTION_LIST:"TransactionList",
    RN_NVI:"Nvi",
}
